export default __webpack_public_path__ + "static/media/movie2.b001082a.png";